export class BufferedAction {
    action: (...args: unknown[]) => void;
    options = {};
    currentlyRunning = false;
    pendingExecution = false;
    args: unknown[] = [];
    period = 200;
    /**
     * If false, this will always wait one period before actually triggering
     */
    risingEdge = true;
    /**
     * If true, this will wait until no more changes are being made to trigger.
     * Only works if rising edge is false.
     */
    waitForQuiet = false;
    interruptCount = 0;

    constructor(action: (...args: unknown[]) => void, period = 200, risingEdge = true, waitForQuiet = false) {
        this.action = action;
        this.period = period;
        this.risingEdge = risingEdge;
        this.waitForQuiet = waitForQuiet;
    }

    _execute(): void {
        this.currentlyRunning = true;
        if (this.risingEdge) {
            this.action(...this.args);
        }
        const interruptKey = this.interruptCount;
        setTimeout(() => {
            if (interruptKey !== this.interruptCount) {
                return;
            }
            const pendingExecution = this.pendingExecution;
            if (!pendingExecution) {
                this.currentlyRunning = false;
            }
            if (!this.risingEdge) {
                if (this.waitForQuiet) {
                    if (!pendingExecution) {
                        this.action(...this.args);
                    }
                } else {
                    this.action(...this.args);
                }
            }
            if (pendingExecution) {
                this.pendingExecution = false;
                this._execute();
            }
        }, this.period);
    }

    trigger(...args: unknown[]): void {
        this.args = args;
        if (!this.currentlyRunning) {
            this._execute();
        } else {
            this.pendingExecution = true;
        }
    }

    forceExecute(...args: unknown[]): void {
        this.args = args;
        this.forceReset();
        this.action(...this.args);
    }

    forceReset(): void {
        this.interruptCount++;
        this.pendingExecution = false;
        this.currentlyRunning = false;
    }
}
